import { AutoServiceApiV2 } from './AutoServiceApiV2';

export const autoServiceApiV2 = new AutoServiceApiV2();
